import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const StockTransactionProjectTypeReportFilter = (props) => {
  const [form] = Form.useForm();

  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  const [stockSelect, setStockSelect] = useState({
    data: [],
    loading: false,
  });

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.transactionProjectTypeId) {
        conditions.push(
          `transactionProjectTypeId eq  ${values.transactionProjectTypeId}`
        );
      }
      if (values.stockId) {
        conditions.push(`stockId eq ${values.stockId}`);
      }

      if (values.projectCode) {
        conditions.push(odata.contains("projectCode", values.projectCode));
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const getRules = () => {
    setProjectSelect({
      ...projectSelect,
      loading: true,
    });
    RequestHandler.get(
      `/StockTransactionProjectType/GetListByStockId/${props.stockId}`
    ).then((res) => {
      setProjectSelect({
        data: res,
        loading: false,
      });
    });
  };

  const onStockSearch = (value) => {
    if (value.length >= 2) {
      setStockSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Stock?$select=id,stockCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("stockCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setStockSelect({ data: res.value, loading: false });
      });
    } else {
      setStockSelect({ data: [], loading: false });
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionProjectTypeId" label="Depo Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectSelect.loading}
                    >
                      {projectSelect?.data?.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="projectCode" label="Depo Kodu :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="stockId" label="Ürün Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onStockSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={stockSelect.loading}
                    >
                      {stockSelect?.data?.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.stockCode}
                        >
                          {item.name + " (" + item.stockCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default StockTransactionProjectTypeReportFilter;
